<template>
  <b-row v-if="parentPath && path">
    <b-col md="12">
      <b-card
        class="card-panel"
        :style="{
          backgroundColor: coloreSfondo,
          color: coloreTesto,
          borderColor: coloreBordo
        }"
      >
        <!-- :header="uniTranslation('S446')"  -->
        <div class="row">
          <div class="col-xl-6 col-lg-12">
            <UnidataEditor
              :parent-path="path"
              :name="'.totalCapacity'"
              :show-input="1"
              :show-output1="!modalitaExpert ? 0 : 1"
              :override-input-class="modalitaExpert ? undefined : 'col-12'"
              :override-output1-class="undefined"
            ></UnidataEditor>
          </div>
          <div class="col-xl-6 col-lg-12">
            <div>
              <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
              <UnidataEditor
                :parent-path="path"
                :name="'.delta'"
                :fixed-decimals="2"
              ></UnidataEditor>
            </div>
          </div>

          <div style="margin-top: 10px" class="col-xl-3 col-lg-6" v-if="isSelezione">
            <label v-tooltip="uniToolTipTranslation('TRNSL39', 'en-US')"
              >{{ uniTranslation("TRNSL39") }} - {{ tollNeg }}</label
            >
            <el-slider v-model="tollNeg" :step="sliderStep" />
          </div>
          <div style="margin-top: 10px" class="col-xl-3 col-lg-6" v-if="isSelezione">
            <label v-tooltip="uniToolTipTranslation('TRNSL187', 'en-US')"
              >{{ uniTranslation("TRNSL187") }} - {{ tollPos }}</label
            >
            <el-slider v-model="tollPos" :step="sliderStep" />
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import UnidataEditor from "../unidata/UnidataEditor";
import { mapActions, mapGetters } from "vuex";
import { Slider } from "element-ui";
import jsonHelper from "../../shared/jsonHelper";

export default {
  components: {
    UnidataEditor,
    [Slider.name]: Slider /*,
    "el-select": Select,
    "el-option": Option,
    "el-collapse": Collapse,
    "el-collapse-item": CollapseItem*/
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      path: null,
      modalitaExpert: false,
      coloreSfondo: "",
      coloreTesto: "",
      coloreBordo: "",
      tollPos: 0,
      tollNeg: 0,
      sliderStep: 5
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects","isSelezione"]),
    ...mapGetters("_colorsModule", ["cardColors"])
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    },
    cardColors() {
      this.setColors();
    },
    tollPos: function(newval /*, oldval*/) {
      this.changeProperty({
        path: this.parentPath + ".bottomSelection.capacityTolerancePositive",
        value: newval
      });
    },
    tollNeg: function(newval /*, oldval*/) {
      this.changeProperty({
        path: this.parentPath + ".bottomSelection.capacityToleranceNegative",
        value: newval
      });
    },
  },
  mounted: function() {
    if (this.parentPath && this.localPath) this.path = this.parentPath + this.localPath;
    var that = this;
    that.setColors();
    that.modalitaExpert = true; //=> in modo da visualizzare sempre i dati di calcolo!!! => è una sua Richiesta del 20.01.20! !
    
      that.tollPos = jsonHelper.getProperty(
        that.projects,
        that.parentPath + ".bottomSelection.capacityTolerancePositive"
      );
      that.tollNeg = jsonHelper.getProperty(
        that.projects,
        that.parentPath + ".bottomSelection.capacityToleranceNegative"
      );
  },
  methods: {
    ...mapActions("_prjModule", ["changeProperty"]),
    setColors() {
      var that = this;
      that.coloreSfondo = that.cardColors[0] + " !important"; // 7 elementi. 0=sfondo 1=barra titolo 2=testo 3=colore titolo 4= sfondo tab 5=testo tab 6=testo titolo tab quando selezionata
      that.coloreBarraTitolo = that.cardColors[1];
      that.coloreTesto = that.cardColors[2];
      that.coloreTitolo = that.cardColors[3];
      that.coloreBordo = that.cardColors[6];
    }
  }
};
</script>

<style lang="scss"></style>
